import { useEffect } from "react";
import { useSelector } from "react-redux";

import { sendEvent } from "shared/DataLayer";
import Loading from "shared/Loading";

const ReferralsPage = () => {
  const { auth: { user } } = useSelector(s => s);

  useEffect(() => {
    if (!user) return;

    sendEvent("portalReferralsPage", user);
  }, [user]);

  if (!user) {
    return <Loading />;
  }

  // Mention Me Referrals Page
  return (
    <>
      <div class="mmWrapper" id="mmWrapper"></div>

      <style>
        {`
          .mmWrapper #mmContentDashboard {
            width: 100%;
          }
        `}
      </style>
    </>
  );
};

export default ReferralsPage;
